
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeItemExtGrid extends Serenity.EntityGrid<PsDiscCouponTypeItemExtRow, any> {
        protected getColumnsKey() { return PsDiscCouponTypeItemExtColumns.columnsKey; }
        protected getDialogType() { return PsDiscCouponTypeItemExtDialog; }
        protected getIdProperty() { return PsDiscCouponTypeItemExtRow.idProperty; }
        protected getInsertPermission() { return PsDiscCouponTypeItemExtRow.insertPermission; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeItemExtRow.localTextPrefix; }
        protected getService() { return PsDiscCouponTypeItemExtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}